import React, { useEffect, useState } from "react";
import { Card, Row, Col, Select, Button, message } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE from "../config/api";
import { enterAdminMerchantMode } from "../utils/adminMerchantMode";
import { showError } from '../utils/errorHandler';

const LoginAsMerchant = () => {
  const navigate = useNavigate();
  const [merchantList, setMerchantList] = useState([]);
  const [selectedMerchant, setSelectedMerchant] = useState(null);

  const fetchMerchants = async () => {
    try {
      const { data } = await axios.get(`${API_BASE}/fetchMerchantForMode`);
      const list = data?.data || [];
      setMerchantList(list);
    } catch (err) {
      console.error(err);
      showError(err, "Couldn't load the merchant list. Please try again.");
    }
  };

  useEffect(() => {
    fetchMerchants();
  }, []);

  const handleLoginAsMerchant = () => {
    if (!selectedMerchant) {
      message.error("Please select a merchant first");
      return;
    }

    // Set same localStorage as user login - gives admin direct access to user pages
    localStorage.setItem("customer_id", selectedMerchant.customer_id);
    localStorage.setItem("phone", selectedMerchant.mobile || "");

    // Explicit marker that this session reached Merchant Mode via a real
    // merchant picked from the fetchMerchantForMode list — the only signal
    // isAdminMerchantMode() trusts (see src/utils/adminMerchantMode.js).
    enterAdminMerchantMode();

    message.success(
      `Logged in as ${selectedMerchant.full_name || selectedMerchant.name}`,
    );
    // Merchant-facing screens read customer_id from localStorage directly
    // when in Admin Merchant Mode (see src/utils/adminMerchantMode.js), so
    // no route state is needed here.
    navigate("/modes");
  };

  return (
    <div className="modSpace">
      <h2>Login as Merchant</h2>

      <div className="relContnet">
        <Select
          showSearch
          virtual={false}
          style={{ width: 300, marginBottom: 20 }}
          placeholder="Select Merchant"
          value={selectedMerchant?.customer_id || null}
          onChange={(customer_id) => {
            const merchant = merchantList.find(
              (m) => m.customer_id === customer_id,
            );
            setSelectedMerchant(merchant);
          }}
          filterOption={(input, option) =>
            option.label.toLowerCase().includes(input.toLowerCase())
          }
          options={Array.from(
            new Map(
              merchantList.map((m) => [
                m.customer_id,
                { label: m.full_name, value: m.customer_id },
              ]),
            ).values(),
          )}
        />

        {selectedMerchant && (
          <div className="boxDivs">
            <h3>Selected Merchant</h3>
            <p>
              <b>Name:</b> {selectedMerchant.name}
            </p>
            <p>
              <b>Mobile:</b> {selectedMerchant.mobile || "N/A"}
            </p>
            <p>
              <b>Customer ID:</b> {selectedMerchant.customer_id}
            </p>
          </div>
        )}

        <Button
          type="primary"
          className="adMode-btn"
          onClick={handleLoginAsMerchant}
          disabled={!selectedMerchant}
        >
          Login
        </Button>
      </div>
    </div>
  );
};

export default LoginAsMerchant;
